var _style, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFloatMenuLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "\\u5716\\u5C64_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 70.3 33.8",
    style: {
      enableBackground: "new 0 0 70.3 33.8"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#E53323;}\n\t.st1{fill:#FFFFFF;}\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M24.3,12.9V8.6H13v4.3H24.3z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M8.7,8.6V4.3H4.4v4.3H8.7z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M24.3,4.3V0H13v4.3H24.3z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M12.9,13H8.6v11.3h4.3V13z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M4.3,13H0v11.3h4.3V13z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M61.7,17.6h-1.1v2.9h1.1V17.6z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M61.7,21.7h-1.1v2.9h1.1V21.7z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M57.7,20.5v1.1h2.9v-1.1H57.7z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M61.7,20.5v1.1h2.9v-1.1H61.7z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M35.7,15.9v-3.1h-3v3.1h-1.1V8.6h1.1v3.1h3V8.6h1.1v7.2H35.7z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M38.3,15.9V8.6h1.1v7.2H38.3z M42.1,15.9l-2.7-3.6l2.7-3.6h1.3l-2.8,3.6l2.8,3.6H42.1z"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M44.5,15.9V8.6H47c2.2,0,3.5,1.7,3.5,3.6c0,2.2-1.4,3.6-3.7,3.6H44.5z M46.8,14.9c1.7,0,2.7-1,2.7-2.6 c0-1.6-1.1-2.7-2.6-2.7h-1.3v5.3H46.8L46.8,14.9z"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M58.4,14.1c-0.7,1.3-1.9,1.9-3.3,1.9c-2,0-3.7-1.8-3.7-3.7c0-2.2,1.7-3.8,3.7-3.8c1.4,0,2.6,0.6,3.4,2h-1.3 c-0.5-0.6-1.2-1-2-1c-1.5,0-2.7,1.3-2.7,2.7c0,1.5,1.1,2.9,2.6,2.9c0.8,0,1.4-0.3,2-1L58.4,14.1L58.4,14.1z"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M31.7,33.7v-7.2h3.7v1h-2.6v2.2h2.6v1h-2.6v3.1L31.7,33.7L31.7,33.7z"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M36.8,33.7v-7.2H41v1h-3.2v2.1H41v1h-3.2v2.2H41v1L36.8,33.7L36.8,33.7z"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M42.7,33.7v-7.2h1.1v6.3h2.5v1L42.7,33.7L42.7,33.7z"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M45.5,33.7v-7.2h1.1v6.3H49v1L45.5,33.7L45.5,33.7z"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M52.7,33.8c-2,0-3.7-1.7-3.7-3.7c0-2.2,1.7-3.8,3.7-3.8c2.1,0,3.8,1.7,3.8,3.7C56.6,32.2,54.9,33.8,52.7,33.8 L52.7,33.8z M55.5,30.1c0-1.5-1.1-2.8-2.7-2.8c-2,0-2.8,1.7-2.8,2.8c0,1.5,1.1,2.8,2.7,2.8C54.5,32.8,55.5,31.4,55.5,30.1L55.5,30.1 z"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M62.5,33.7l-1.3-5h0l-1.3,5h-0.9l-2-7.2H58l1.4,5.4h0l1.4-5.4h0.8l1.4,5.4h0l1.4-5.4h1.1l-2,7.2H62.5L62.5,33.7 z"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M69.1,28.3c0-0.7-0.4-1-1-1c-0.5,0-1,0.5-1,1s0.3,0.8,1,1c1.6,0.5,2.1,1.1,2.1,2.3c0,1.2-0.9,2.2-2.2,2.2 c-1.3,0-2.2-0.9-2.2-2.3h1.1c0,0.8,0.5,1.3,1.2,1.3s1.2-0.5,1.2-1.2c0-0.5-0.2-0.9-1-1.1c-1.8-0.6-2.2-1.2-2.2-2.2c0-1.1,0.9-2,2-2 c1.2,0,2.1,0.8,2.1,2L69.1,28.3L69.1,28.3z"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M31.7,24.7v-7.2h3.7v1h-2.6v2.2h2.6v1h-2.6v3.1L31.7,24.7L31.7,24.7z"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M40.9,24.7l-0.8-2.1h-2.6l-0.8,2.1h-1.1l2.8-7.2h0.9l2.8,7.2H40.9L40.9,24.7z M38.8,18.8L38.8,18.8l-0.9,2.8 h1.9L38.8,18.8z"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M47.3,24.7l-3.6-5.6h0v5.6h-1.1v-7.2h1.2l3.5,5.5h0v-5.5h1.1v7.2H47.3z"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M52.9,19.3c0-0.7-0.4-1-1-1c-0.5,0-1,0.5-1,1s0.3,0.8,1,1c1.6,0.5,2.1,1.1,2.1,2.3c0,1.3-0.9,2.2-2.2,2.2 c-1.3,0-2.2-0.9-2.2-2.3h1.1c0,0.8,0.5,1.3,1.2,1.3c0.7,0,1.2-0.5,1.2-1.2c0-0.5-0.2-0.9-1-1.1c-1.8-0.6-2.2-1.2-2.2-2.2 c0-1.1,0.9-2,2-2c1.2,0,2.1,0.8,2.1,2L52.9,19.3L52.9,19.3z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFloatMenuLogo);
export default __webpack_public_path__ + "static/media/float-menu-logo.b674fa49bff612a05f32ddf2d5567dd7.svg";
export { ForwardRef as ReactComponent };